var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { withFormsy } from 'formsy-react';
import * as React from 'react';
import { TextField } from '@material-ui/core';
import * as _ from 'lodash';
var TextFieldFormsy = /** @class */ (function (_super) {
    __extends(TextFieldFormsy, _super);
    function TextFieldFormsy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeValue = function (event) {
            _this.props.setValue(event.target.value);
        };
        return _this;
    }
    TextFieldFormsy.prototype.render = function () {
        var importedProps = _.pick(this.props, [
            'autoComplete',
            'autoFocus',
            'children',
            'className',
            'defaultValue',
            'disabled',
            'FormHelperTextProps',
            'fullWidth',
            'id',
            'InputLabelProps',
            'inputProps',
            'InputProps',
            'inputRef',
            'label',
            'multiline',
            'name',
            'onBlur',
            'onChange',
            'onFocus',
            'placeholder',
            'required',
            'rows',
            'rowsMax',
            'select',
            'SelectProps',
            'type',
        ]);
        var errorMessage = this.props.getErrorMessage();
        var value = this.props.getValue() || '';
        return (React.createElement(TextField, __assign({}, importedProps, { onChange: this.changeValue, value: value, error: Boolean(errorMessage), helperText: errorMessage })));
    };
    return TextFieldFormsy;
}(React.Component));
export default withFormsy(TextFieldFormsy);



//////////////////
// WEBPACK FOOTER
// ./src/theme/components/TextFieldFormsy.tsx
// module id = 790
// module chunks = 81